import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { IndicatorState } from "src/app/indicator/indicator.state";

@Component({
  selector: "app-viewset-container",
  templateUrl: "./viewset-container.component.html"
})
export class ViewSetContainerComponent implements OnInit {
  @Input() closeMenu = false;
  @Output() menuOpened: EventEmitter<void> = new EventEmitter();
  @Output()
  selectedViewSetChanged: EventEmitter<string> = new EventEmitter();

  viewsets = [];
  title: string;

  ngOnInit() { }

  onStateUpdated(state: IndicatorState) {
    this.title = state.Meta.locations.map(x => x.presentations).reduce((acc, x) => acc.concat(x), []).find(
      (viewset) => viewset.viewSetName === state.ViewSet
    ).viewSetTitle;

    this.viewsets = [];
    // get the viewsets for the current location, sort them by position and add them to the viewsets array
    state.Meta.locations.filter(l => l.name === state.Location).map(x => x.presentations).reduce((acc, x) => acc.concat(x), []).sort((a, b) => a.position - b.position).forEach((presentation) =>
      this.viewsets.push([presentation.viewSetName, presentation.viewSetTitle])
    );
  }

  onViewSetClicked(id: any) {
    this.selectedViewSetChanged.emit(id);
  }

  onMenuOpened() {
    // emit an event to the parent component to close any other open menus
    this.menuOpened.emit();
  }
}
